jQuery( document ).ready(function($) {

  console.log('jooo');
  console.log('Scripttttttt loadedddddddddd !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
  
document.addEventListener("DOMContentLoaded", function() {
  var closeBtn = document.getElementById("close-cart");
  var cartModal = document.getElementById("mobile-cart-modal");

  // Open the modal (this could be triggered by another action like a button click)
  function openCartModal() {
    cartModal.style.display = "block";
  }

  // Close the modal when the close button is clicked
  closeBtn.addEventListener("click", function() {
    cartModal.style.display = "none";
  });

  // Optionally, add functionality to close the modal when clicking outside of the modal content
  cartModal.addEventListener("click", function(event) {
    if (event.target === cartModal) {
      cartModal.style.display = "none";
    }
  });

  // Example to trigger the modal open (You could hook this to your cart icon or button)
  // openCartModal();
});
  
document.addEventListener('click', handleCartInteraction);
document.addEventListener('touchstart', handleCartInteraction);

function handleCartInteraction(e) {
    const miniCartInput = document.querySelector('[data-minicart-input]');
    const overlay = document.querySelector('.test.overlay');

    if (miniCartInput) {
        // Close minicart when overlay is clicked or touched
        if (e.target === overlay) {
            miniCartInput.checked = false; // Uncheck the checkbox to close
        }

        // Close minicart when a close button is clicked or touched
        if (e.target.closest('.close_minicart')) {
            miniCartInput.checked = false; // Uncheck the checkbox to close
        }
    }
}
 

 $('[class*=common]').each(function() {
        var $element = $(this);
        
        // Get the classes of the current element
        var classes = $element.attr('class').split(' ');

        // Iterate over each class
        $.each(classes, function(index, className) {
            // Check if the class starts with "section-"
            if (className.indexOf("section-") === 0) {
                // Extract the part after "section-"
                var extractedClass = className.replace("section-", "");
                
                // Add extracted class to the parent's class list
                $element.parent().addClass(extractedClass);
                
                // Remove extracted class from the current element's class list
                $element.removeClass(className);
            }
        });
    });




  
$('#shopify-section-footer').show();
$('#shopify-section-subfooter').show();


   window.setTimeout( loadShopifySection, 16000 ); // 16 seconds

function loadShopifySection() {
  
  $('#smile-ui-container').css('visibility','visible');
  $('#smile-ui-container').css('opacity','1');
}




$("#accordion").accordion({
  icons: false,
  heightStyle: "content",
  activate: function(event, ui) {
    var isActive = $(ui.newHeader).hasClass("ui-state-active");
    $(this)
      .find(".ui-accordion-header i")
      .removeClass("fa-minus2")
      .addClass("fa-plus2");
    $(ui.newHeader)
      .find("i")
      .removeClass("fa-plus2")
      .toggleClass("fa-minus2", isActive);
  }
});

$("#accordion .ui-accordion-header").click(function() {
  // No need for this part anymore
});
  
 /* $( "#accordion" ).accordion({
	  icons: false,
	 heightStyle: "content"
    });
  	$("#accordion .ui-accordion-header").click(function() {
  $(this)
    .children("i")
    .toggleClass("fa-plus2 fa-minus2");
  $(".ui-accordion-header")
    .not($(this))
    .children("i")
    .removeClass("fa-minus2");
  $(".ui-accordion-header")
    .not($(this))
    .children("i")
    .addClass("fa-plus2");
});
*/

var popover_template='<div class="popover test" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>';
var pop_options = {
  container: '.custom-bootstrap-body',
  trigger: 'focus'
}  
$('[data-toggle="popover"]').popover(pop_options);
 $('.free-pop').on('shown.bs.popover', function () {
  $('.custom-bootstrap-body').addClass('pop-over-active');
});
   $('.free-pop').on('hidden.bs.popover', function () {
 $('.custom-bootstrap-body').removeClass('pop-over-active');
});

  $( window ).on( "booster:content:update booster:cart:update", function( event ) {
 
    var swiperBought = new Swiper(".swiper-bought-slider", {
       slidesPerView: 1,
      spaceBetween: 20,
       loop: true,
     navigation: {
        nextEl: '.bought-cart-slider .swiper-button-next-custom',
        prevEl: '.bought-cart-slider .swiper-button-prev-custom',
      }
    });
  
});

});